import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = '/vocs';

const vocManaApi = {
  triggerEvents(params: any): Promise<any> {
    const url = `${path}`
    return api.get(url, params)
  },

  vocList(params: any): Promise<any> {
    const url = `${path}`
    return api.get(url, params)
  },

  vocReasons(params: any): Promise<any> {
    const url = `${path}/reasons`
    return api.get(url, params)
  },

  vocReasonsAll(params: any): Promise<any> {
    const url = `${path}/reasons/all`
    return api.get(url, params)
  },

  getVOCReason(id: string | number, params: any = {}): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },

  postVOCReason(dataForm: any): Promise<any> {
    const url = `${path}/reasons`;
    return api.post(url, dataForm)
  },

  putVOCReason(id: string | number, dataForm: any): Promise<any> {
    const url = `${path}/reasons/${id}`;
    return api.put(url, dataForm)
  },

  deleteVOCReason(id: string | number, dataForm: any): Promise<any> {
    const url = `${path}/reasons/${id}`;
    return api.delete(url, dataForm)
  },

  allOperators(params: any = {}): Promise<any> {
    const url = `masters/admins`
    return api.get(url, params)
  },
}
export default vocManaApi
